'use client';

import dynamic from "next/dynamic";
import VideoConsoleLogger from "@/components/VideoConsoleLogger";

const Banner = dynamic(() => import("@/components/Home2/Banner"));
const ChancellorSection = dynamic(
  () => import("@/components/Home2/ChancellorSection"),
);
const FeaturesSection = dynamic(
  () => import("@/components/Home2/FeaturesSection"),
);
const StudentStoriesSection = dynamic(
  () => import("@/components/Home2/StudentStoriesSection"),
);
const ProgramsSection = dynamic(
  () => import("@/components/Home2/ProgramsSection"),
);
const AwardsSection = dynamic(() => import("@/components/Home2/AwardsSection"));
const Logo = dynamic(() => import("@/components/Home2/Logo"));
const PartnershipSection = dynamic(
  () => import("@/components/Home2/PartnershipSection"),
);
const CampusSection = dynamic(() => import("@/components/Home2/CampusSection"));
const FromCampusToCareer = dynamic(
  () => import("@/components/Home2/FromCampusToCareer"),
);
const LifeAtMsuSection = dynamic(
  () => import("@/components/Home2/LifeAtMsuSection"),
);
const Blog = dynamic(() => import("@/components/Blog"));
const FooterCTA = dynamic(() => import("@/components/Home2/FooterCTA"));
const FAQSection = dynamic(() => import("@/components/Home2/Faq"));

// All data now arrives as props, fetched server-side in page.js, so every
// section is in the SSR HTML. Don't wrap sections in `content-visibility: auto`
// (.cv-auto): skipped content is excluded from innerText and left unpainted in
// headless renders, so SEO/screenshot tools only saw the first few sections.
const HomeClientWrapper = ({ pageData, blogs }) => {
  const partnershipData = pageData?.attributes?.Partnership || pageData?.Partnership;
  const featuresData = pageData?.attributes?.Features || pageData?.Features;
  const studentTestimonialData =
    pageData?.attributes?.Student_Testimonial || pageData?.Student_Testimonial;

  const programData =
    pageData?.attributes?.Program_and_schools || pageData?.Program_and_schools;
  const awardsData = pageData?.attributes?.Awards || pageData?.Awards;
  const recognitionsData =
    pageData?.attributes?.Recognitions || pageData?.Recognitions;
  const countersData = pageData?.attributes?.counters || pageData?.counters;
  const partnerLogosData =
    pageData?.attributes?.partner_logos || pageData?.partner_logos;
  const infrastructureData =
    pageData?.attributes?.Infrastructure || pageData?.Infrastructure;
  const placementsData =
    pageData?.attributes?.Placements || pageData?.Placements;
  const lifeAtMsuData =
    pageData?.attributes?.lifeAtMsu || pageData?.lifeAtMsu;
  const blogSectionData = pageData?.attributes?.Blog || pageData?.Blog;
  const faqSectionData = pageData?.attributes?.Faqs || pageData?.Faqs;

  return (
    <>
      <VideoConsoleLogger />
      <Banner />
      <ChancellorSection data={partnershipData} loading={false} />
      <FeaturesSection data={featuresData} loading={false} />
      <StudentStoriesSection data={studentTestimonialData} loading={false} />

      <ProgramsSection data={programData} loading={false} />
      <AwardsSection data={awardsData} loading={false} />
      <Logo data={recognitionsData} loading={false} />
      <PartnershipSection
        data={countersData}
        partnerLogosData={partnerLogosData}
        loading={false}
      />
      <CampusSection data={infrastructureData} loading={false} />
      <FromCampusToCareer data={placementsData} loading={false} />
      <LifeAtMsuSection data={lifeAtMsuData} loading={false} />
      <Blog data={blogs} sectionData={blogSectionData} />
      <FAQSection data={faqSectionData} />

      <FooterCTA />
    </>
  );
};

export default HomeClientWrapper;